// extracted by css-extract-rspack-plugin
export default {"ListRoot":"UUkrB"};